import { motion } from "framer-motion";

const MessageList = ({
  messages,
  currentOption,
  handlePartnershipSelection,
  handleSkip,
}) => {
  return (
    <div className="p-4 h-72 sm:h-80 md:h-96 overflow-y-auto noScrollbar">
      {messages.map((msg, index) => (
        <div
          key={index}
          className={`${msg.from === "bot" ? "text-left" : "text-right"} my-2`}
        >
          <span
            className={`inline-block p-2 rounded-xl px-3 font-body ${
              msg.from === "bot"
                ? "bg-gray-100 text-gray-700"
                : "bg-green-500 text-white"
            }`}
          >
            {msg.text}
          </span>
        </div>
      ))}

      {currentOption === "Partnership Assistance" && (
        <div className="flex flex-col gap-2 mt-3 bg-gray-100 rounded-3xl shadow-sm">
          {[
            "Vendor Partnership",
            "Design Partnership",
            "Store Partnership",
            "Handyman Partnership",
            "Corporate Partnership",
            "Project Partnership",
          ].map((option) => (
            <motion.button
              key={option}
              className="bg-white mx-4 my-2 p-2 text-gray-800 py-2 px-4 rounded-full"
              onClick={() => handlePartnershipSelection(option)}
              whileHover={{ scale: 1.06 }}
            >
              {option}
            </motion.button>
          ))}
        </div>
      )}

      {currentOption && (
        <div className="mt-4 text-right">
          <motion.p
            className="text-gray-700 font-body py-2 rounded-xl px-4 cursor-pointer"
            whileHover={{ scale: 1.02 }}
            onClick={handleSkip}
          >
            Skip >>
          </motion.p>
        </div>
      )}
    </div>
  );
};

export default MessageList;
